import { useLanguage } from '@/contexts/LanguageContext';
import { Wrench, GraduationCap, DollarSign, TrendingUp } from 'lucide-react';
import ScrollReveal from '@/components/animations/ScrollReveal';
const BenefitsSection = () => {
  const {
    t
  } = useLanguage();
  const benefits = [{
    icon: Wrench,
    title: t('benefits.skills.title'),
    desc: t('benefits.skills.desc'),
    color: 'bg-sunset-500'
  }, {
    icon: GraduationCap,
    title: t('benefits.training.title'),
    desc: t('benefits.training.desc'),
    color: 'bg-forest-700'
  }, {
    icon: DollarSign,
    title: t('benefits.paid.title'),
    desc: t('benefits.paid.desc'),
    color: 'bg-teal-500'
  }, {
    icon: TrendingUp,
    title: t('benefits.growth.title'),
    desc: t('benefits.growth.desc'),
    color: 'bg-sky-500'
  }];
  return <section className="py-section-mobile md:py-section-desktop bg-sand-50 relative z-10">
      {/* Decorative gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-sand-100/30 to-transparent" />

      <div className="container mx-auto px-md lg:px-lg relative z-10">
        <div className="max-w-3xl mx-auto text-center mb-2xl">
        <ScrollReveal delay={100} threshold={0.5}>
            <h2 className="text-h2 md:text-[40px] font-bold text-forest-900 mb-md">
              {t('benefits.title')}
            </h2>
          </ScrollReveal>
          <ScrollReveal delay={200} threshold={0.5}>
            <p className="text-stone-500 max-prose mx-auto text-xl">
              {t('benefits.subtitle')}
            </p>
          </ScrollReveal>
        </div>

        <div className="grid md:grid-cols-2 gap-lg max-w-4xl mx-auto">
          {benefits.map((benefit, index) => <ScrollReveal key={index} delay={300 + index * 150} threshold={0.5}>
              <div className="flex gap-lg p-lg rounded-xl bg-card shadow-card border border-border hover-lift h-full">
                <div className={`w-14 h-14 rounded-lg ${benefit.color} flex items-center justify-center shrink-0`}>
                  <benefit.icon className="h-7 w-7 text-sand-50" />
                </div>
                <div>
                  <h3 className="text-h3 font-bold text-forest-900 mb-xs">
                    {benefit.title}
                  </h3>
                  <p className="text-body text-stone-500 leading-relaxed">
                    {benefit.desc}
                  </p>
                </div>
              </div>
            </ScrollReveal>)}
        </div>
      </div>
    </section>;
};
export default BenefitsSection;